import * as React from 'react'
import { CellContext } from '@tanstack/react-table'
import { User } from 'store/modules/users'

function getActiveStatus(user: User) {
  if (!user.currentSignInAt) return 'Pending' //show user status pending until first login
  if (user.state === 'active') return 'Active'
  if (user.state === 'archived') return 'Archived'
  if (user.state === 'not_invited') return 'Pending'
  return null
}

export const StatusCell = (data: CellContext<User, unknown>) => {
  const user = data.row.original
  const status = getActiveStatus(user)

  if (!status) return null

  const statusColors: Record<string, string> = {
    Active: 'text-green-600 bg-green-100',
    Archived: 'text-gray-600 bg-gray-100',
    Pending: 'text-yellow-600 bg-yellow-100',
  }

  return (
    <div
      className={`px-2 py-1 text-sm font-medium inline-block ${statusColors[status]}`}
    >
      {status}
    </div>
  )
}
